<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="!this.loading && !this.errormessage">
      <card class="mt-3">
        <h4 class="card-title mt-1">
          {{ receiptType }} Receipts
        </h4>
        <el-table
          :data="rowData"
          header-row-class-name="text-danger text-left"
          size="small"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
          @cell-click="onCellClick"
          v-if="rowData.length > 0"
        >
          <el-table-column
            label="Receipt Date"
            sortable
            :formatter="dateFormatter"
            property="ReceiptDate"
            class-name="text-left"
            width="130px"
          />
          <el-table-column
            label="Title"
            class-name="d-none d-md-table-cell"
            sortable
            property="Title"
          />
          <el-table-column
            :label="payeeLabel"
            sortable
            property="Payee"
            class-name="d-none d-md-table-cell text-break"
          />
          <el-table-column
            :label="payerLabel"
            sortable
            property="PayerName"
          />
          <el-table-column
            label="Memo"
            sortable
            property="Memo"
            class-name="d-none d-md-table-cell"
          />
          <el-table-column
            label="Budget Item"
            sortable
            class-name="d-none d-md-table-cell"
            width="120px"
          >
            <template slot-scope="props">
              <span :class="{ pointer: props.row.NumberOfItems > 1, 'text-primary': props.row.NumberOfItems > 1 }">{{ props.row.BudgetItemName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Amount"
            sortable
            :formatter="currencyFormatter"
            property="Amount"
            header-class-name="text-right"
            class-name="text-right"
            width="100px"
          />
          <el-table-column
            class-name="d-none d-md-table-cell action-buttons td-actions"
            align="right"
            width="140"
            label=""
          >
            <template slot-scope="props">
              <p-button
                type="info"
                size="sm"
                class="mt-1 mb-1"
                title="Edit receipt"
                icon
                @click="showEditDialog(props.row)"
              >
                <i class="fa fa-edit" />
              </p-button>
              <p-button
                type="info"
                size="sm"
                class="mt-1 mb-1"
                title="Show/Update Image"
                icon
                @click="showImage(props.row)"
              >
                <i class="bi bi-image" />
              </p-button>
              <p-button
                type="danger"
                size="sm"
                class="mt-1 mb-1"
                title="Delete Receipt"
                icon
                @click="confirmDeleteReceipt(props.row)"
              >
                x
              </p-button>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-else
          class="text-center"
        >
          <p class="card-category">
            There are no {{ receiptType }} receipts turned in for this course.
          </p>
        </div>
        <p-button
          type="info"
          title="Add Receipt"
          @click="showAddNewDialog()"
        >
          Add {{ receiptType }} Receipt
        </p-button>
      </card>
    </div>
    <modal
      :show.sync="showEdit"
      class="modal-primary"
      ref="editModal"
      :show-close="false"
      header-classes="justify-content-center"
    >
      <div
        slot="header"
        class="ml-4"
      >
        <h6><i class="ti ti-receipt mr-2" /><span class="text-danger">{{ editReceipt.ReceiptId === 0 ? 'Add' : 'Update' }} {{ receiptType }} Receipt</span></h6>
      </div>
      <card v-click-outside="closeEditDialog">
        <ValidationObserver ref="form">
          <form @submit.prevent="saveReceipt">
            <ValidationProvider
              name="receiptDate"
              rules="required"
            >
              <fg-input
                required
                slot-scope="{ errors }"
                :error="errors[0] ? 'Please provide the date of this receipt.': '' "
              >
                <label class="control-label">Receipt Date <span class="text-danger">*</span></label>
                <el-date-picker
                  v-model="editReceipt.ReceiptDate"
                  format="dd MMM yyyy  h:mm a"
                  value-format="yyyy-MM-ddTHH:mm:ss"
                  type="datetime"
                />
              </fg-input>
            </ValidationProvider>
            <ValidationProvider
              name="receiptTitle"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <label class="control-label">Receipt Description <span class="text-danger">*</span></label>
              <fg-input
                name="receiptTitle"
                required
                :error="failed ? 'Please provide a title for this receipt.': null"
                :has-success="passed"
                v-model="editReceipt.Title"
              />
            </ValidationProvider>
            <ValidationProvider
              name="payee"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <label class="control-label">{{ payeeLabel }} <span class="text-danger">*</span></label>
              <fg-input
                name="payee"
                required
                :error="failed ? payeeErrorMessage : null"
                :has-success="passed"
                v-model="editReceipt.Payee"
              />
            </ValidationProvider>
            <ValidationProvider
              name="payer"
              rules="required"
            >
              <fg-input
                slot-scope="{ errors }"
                :error="errors[0] ? payerErrorMessage : '' "
              >
                <label class="control-label">{{ payerLabel }} <span class="text-danger">*</span></label>
                <el-select
                  class="select-default2"
                  size="large"
                  name="payer"
                  placeholder=""
                  clearable
                  v-model="editReceipt.ScouterKey"
                >
                  <el-option
                    v-for="(data,index) in staff"
                    class="select-default2"
                    :value="index"
                    :label="data"
                    :key="data"
                  />
                </el-select>
              </fg-input>
            </ValidationProvider>
            <fg-input>
              <label class="control-label">Memo</label>
              <textarea
                class="form-control"
                type="text"
                placeholder=""
                v-model="editReceipt.Memo"
              />
            </fg-input>
            <div class="text-right">
              <p-button
                type="success"
                native-type="submit"
                class="mr-2"
              >
                Save
              </p-button>
            </div>
          </form>
        </ValidationObserver>
      </card>
      <card :class="{ 'readonly-box' : editReceipt.Id === 0 }">
        <el-table
          :data="editReceipt.Items"
          header-row-class-name="text-danger text-left"
          size="small"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
          v-if="editReceipt.Items"
        >
          <el-table-column
            label="Budget Item"
            property="BudgetItemTitle"
            class-name="d-none d-md-table-cell text-left"
          />
          <el-table-column
            label="Amount"
            :formatter="currencyFormatter"
            class-name="text-right"
            property="Amount"
            width="80"
          />
          <el-table-column
            class-name="d-none d-md-table-cell action-buttons td-actions"
            align="right"
            width="70"
            label="Actions"
          >
            <template slot-scope="props">
              <p-button
                type="info"
                style="height:1rem;width:1rem;min-width:1rem;"
                size="xs"
                class="mt-1 mb-1"
                title="Edit"
                icon
                @click="showEditItemDialog(props.row)"
              >
                <i
                  class="fa fa-edit"
                  style="font-size:smaller;"
                />
              </p-button>
              <p-button
                type="danger"
                style="height:1rem;width:1rem;min-width:1rem;"
                size="xs"
                class="mt-1 mb-1"
                title="Delete"
                icon
                @click="deleteItemConfirm(props.row)"
              >
                <i
                  class="fa fa-times"
                  style="font-size:smaller;"
                />
              </p-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="row">
          <div class="col-7 text-left pt-3">
            <strong>Receipt Total</strong>
          </div>
          <div class="col-3 text-right pt-3">
            <strong>{{ currencyFormatter(null, null, editReceipt.Amount, null) }}</strong>
          </div>
          <div class="col-2 text-right pt-3">
            <p-button
              type="success"
              style="height:1rem;width:1rem;min-width:1rem;"
              size="xs"
              class="mt-1 mb-1"
              title="Add Budget Item"
              icon
              @click="showEditItemDialog(null)"
            >
              +
            </p-button>
          </div>
        </div>
      </card>
      <template slot="footer">
        <p-button
          type="default"
          class="mr-2"
          @click="closeEditDialog"
        >
          Close
        </p-button>
      </template>
    </modal>
    <receipt-details-line
      :show.sync="showEditItem"
      :item="editItem"
      :budget-items="budgetItems"
      @update-receipt-line="updateReceiptLine"
    />
    <modal
      :show.sync="showEditImage"
      class="modal-primary"
      ref="editImage"
      :show-close="false"
      header-classes="justify-content-center"
    >
      <div
        slot="header"
        class="ml-4"
      >
        <h6><i class="ti ti-receipt mr-2" /><span class="text-danger">Attach Receipt</span></h6>
      </div>
      <img
        v-if="editReceipt.ImageUrl"
        :src="editReceipt.ImageUrl"
        :title="editReceipt.Title"
      >
      <br>
      <p-button
        type="default"
        class="mr-4"
        @click="showCaptureFile"
      >
        Get Image
      </p-button>
      <p-button
        type="success"
        class="ml-5 mr-2"
        :disabled="disableAttachImageButton"
        @click="attachImage"
      >
        {{ attachImageButtonText }}
      </p-button>
      <p-button
        type="danger"
        class="mr-2"
        @click="showEditImage = false"
      >
        Cancel
      </p-button>
    </modal>
    <capture-file
      ref="captureFile"
      :is-photo="false"
      @url-captured="onCapturedUrl"
    />
  </div>
</template>

<script>
import oops from '@/components/_main/oops.vue'
import receiptApi from '@/services/api/receipt.js'
import budgetApi from '@/services/api/budget.js'
import scouterApi from '@/services/api/scouter.js'
import Modal from '@/plugins/paper-components/modal.vue'
import ReceiptDetailsLine from '@/components/finance/modals/receipt-details-line.vue'
import CaptureFile from '@/components/storage/capture-file.vue'
import formatter from '@/services/formatter.js'

export default {
  name: 'ReceiptDetails',
  components: {
    oops,
    Modal,
    ReceiptDetailsLine,
    CaptureFile
  },
  props: {
    receiptType: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: { padding: '0', height: '20px', 'font-size': '10px', 'overflow-wrap': 'break-word' },
      rowData: [],
      loading: true,
      errormessage: null,
      staff: null,
      showEdit: false,
      showingEdit: false,
      showEditDetails: false,
      editReceipt: {},
      showEditItem: false,
      editItem: {},
      showEditImage: false,
      disableAttachImageButton: true,
      attachImageButtonText: 'Attach',
      selectedParams: null,
      presentationUpdate: {},
      receiptItemDetails: [],
      budgetItems: [],
      tempHolding: null,
      blankReceipt: {
        Id: 0,
        CourseKey: this.$root.courseKey,
        ReceiptDate: null,
        Title: null,
        Payee: null,
        Payer: null,
        ScouterKey: null,
        IsExpense: null,
        ImageName: null,
        Memo: null
      }
    }
  },
  computed: {
    isIncome: function () {
      return this.receiptType === 'Income'
    },
    payeeLabel: function () {
      return this.receiptType === 'Income' ? 'Received From' : 'Paid To'
    },
    payerLabel: function () {
      return this.receiptType === 'Income' ? 'Received By' : 'Paid By'
    },
    payeeErrorMessage: function () {
      return this.receiptType === 'Income' ? 'Please provide who this receipt was received from.' : 'Please provide who this receipt was paid to.'
    },
    payerErrorMessage: function () {
      return this.receiptType === 'Income' ? 'Please provide who received the funds.' : 'Please provide who should be reimbursed.'
    }
  },
  mounted  () {
    this.getStaffList()
    if (this.receiptType === 'Income') {
      this.getIncomeItems()
    } else {
      this.getExpenseItems()
    }
    this.refresh()
  },
  methods: {
    getStaffList: function () {
      scouterApi.getStaffLookups(this.$root.courseKey)
        .then(y => {
          this.staff = y
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveReceipt: function () {
      return this.$refs.form.validate().then(res => {
        if (res) {
          receiptApi.updateReceipt(this.$root.courseKey, this.editReceipt)
            .then(x => {
              this.editReceipt = x
              this.$notify({
                message: 'Update Complete',
                icon: 'nc-icon nc-satisfied',
                type: 'success',
                horizontalAlign: 'center',
                timeout: 2000
              })
            })
            .catch(error => {
              console.log(error)
              this.$notify({
                message: 'There was an error saving your receipt.',
                icon: 'bi bi-exclamation-circle-fill',
                type: 'error',
                horizontalAlign: 'center',
                timeout: 2000
              })
              this.errormessage = error
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    getExpenseItems: function () {
      budgetApi.getExpenseBudgetItems(this.$root.courseKey)
        .then(x => {
          this.budgetItems = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    getIncomeItems: function () {
      budgetApi.getIncomeBudgetItems(this.$root.courseKey)
        .then(x => {
          this.budgetItems = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    refresh: function () {
      receiptApi.getReceipts(this.$root.courseKey, this.isIncome)
        .then(x => {
          this.rowData = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    dateFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsDateTime(cellValue)
    },
    currencyFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsCurrency(cellValue, 2)
    },
    showEditDialog: function (info) {
      this.editReceipt = info
      this.showEdit = true
      this.showingEdit = true
    },
    closeEditDialog: function () {
      if (!this.showingEdit && !this.showEditItem) {
        this.showEdit = false
        this.refresh()
      } else {
        this.showingEdit = false
      }
    },
    showAddNewDialog: function () {
      this.showingEdit = true
      this.editReceipt = this.blankReceipt
      this.editReceipt.IsExpense = !this.isIncome
      this.showEdit = true
    },
    showEditItemDialog: function (item) {
      this.showingEdit = true
      if (item === null) {
        this.editItem = {
          Id: 0,
          ReceiptId: this.editReceipt.Id,
          Amount: null,
          BudgetItemId: null
        }
      } else {
        this.editItem = item
      }
      this.showEditItem = true
    },
    confirmDeleteReceipt: function (receipt) {
      const msg = 'Are you sure you want to delete "' + receipt.Title + '" ?'
      this.$confirm(msg, 'Are you sure?')
        .then(() => {
          this.deleteReceipt(receipt)
        })
    },
    deleteReceipt: function (receipt) {
      receiptApi.deleteReceipt(this.$root.courseKey, receipt.Id, !receipt.IsExpense)
        .then(x => {
          this.rowData = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error deleting your receipt.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
    },
    showImage: function (receipt) {
      this.editReceipt = receipt
      this.disableAttachImageButton = true
      this.attachImageButtonText = 'Attach'
      this.showEditImage = true
    },
    showCaptureFile: function () {
      this.$refs.captureFile.showDialog(this.editReceipt.ImageUrl)
    },
    onCapturedUrl: function (url, fileName) {
      if (url) {
        this.disableAttachImageButton = false
        this.editReceipt.ImageUrl = url
        this.attachImageButtonText = 'Attach'
      } else if (!url && this.editReceipt.ImageUrl) {
        this.disableAttachImageButton = false
        this.editReceipt.ImageUrl = null
        this.attachImageButtonText = 'Detach'
      }
    },
    attachImage: function () {
      this.saveReceipt()
      this.refresh()
      this.showEditImage = false
    },
    updateReceiptLine: function (item) {
      receiptApi.updateReceiptItem(this.$root.courseKey, item)
        .then(x => {
          this.editReceipt = x
          this.$notify({
            message: 'Update Complete',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .catch(error => {
          console.log(error)
          this.errormessage = error
        })
        .finally(() => {
          this.showEditItem = false
        })
    },
    deleteItemConfirm: function (item) {
      const msg = 'Are you sure you want to delete "' + item.BudgetItemTitle + '" ?'
      this.$confirm(msg, 'Are you sure?')
        .then(() => {
          this.deleteItem(item)
        })
    },
    deleteItem: function (item) {
      receiptApi.deleteReceiptItem(this.$root.courseKey, item.ReceiptId, item.Id)
        .then(x => {
          this.editReceipt = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error deleting your receipt line item.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
    },
    onCellClick: function (row, column, cell, event) {
      this.tempHolder = { c: cell, r: row, co: column, e: event }
      if (column.label === 'Budget Item') {
        if (row.NumberOfItems > 1) {
          let htmlString = '<ul>'
          for (let i = 0; i < row.Items.length; i++) {
            htmlString += '<li>' + row.Items[i].BudgetItemTitle + '</li>'
          }
          htmlString += '</ul>'

          this.$alert(htmlString, { dangerouslyUseHTMLString: true })
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .income {
    color: green;
  }
  .expense {
    color: red;
  }
  .readonly-box {
    opacity:.7;
    background-color:gray;
    pointer-events:none;
  }
</style>
